import React from "react";
import { useNavigate } from "react-router-dom";
export default function BreadCrumb({ element }) {
  const navigate = useNavigate();
  return (
    <div className="breadcrumbs">
      <p
        onClick={() => {
          navigate("/dashboard");
        }}
      >
        Home
      </p>
      <p>/</p> <p className="currentpage">{element}</p>
    </div>
  );
}
